var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-select"},_vm._l((_vm.renderable),function(card,idx){return _c('DoKoCard',{key:idx,class:{
      card: true,
      selected: card.selected && _vm.showSelected,
      disabled: card.disabled,
    },attrs:{"img-id":card.name,"w":28},on:{"click":function($event){return _vm.toggleSelection(card.id, card.selected, card.disabled)}}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }